import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { TFunction, withTranslation } from 'react-i18next';
import { KibSectionHeading } from '@chewy/kib-content-groups-react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { useTrack } from '@chewy/use-analytics';
import { autoshipDeactivatedPetsEnabledLoadData } from '../../api/featuresApi';
import { AUTOSHIP_DEACTIVATED_PETS_ENABLED, autoshipPath } from '../../util/config';
import { isClient } from '../../util/helpers';
import './autoship-changes-card.scss';

export type AutoshipChangesCardProps = {
  t: TFunction<string>;
};

const AutoshipChangesCard = ({ t }: AutoshipChangesCardProps) => {
  const { data: featureFlagData } = useQuery(
    autoshipDeactivatedPetsEnabledLoadData.key,
    autoshipDeactivatedPetsEnabledLoadData,
  );

  const isAutoshipDeactivatedPetsEnabled =
    featureFlagData?.[AUTOSHIP_DEACTIVATED_PETS_ENABLED]?.toLowerCase() === 'true';

  const track = useTrack();

  useEffect(() => {
    if (isAutoshipDeactivatedPetsEnabled && isClient()) {
      track('Widget Viewed', {
        id: 'pet-profile-inactive-autoship-notification-banner',
        parentId: 'memorialize-remove-profile',
        ancestorId: '',
        level: 'widget',
        type: 'static',
        subType: '',
        creative: 'autoshipCancelRemoveMessage',
        contentPublisher: 'chewy-petprofile-ui',
        position: '2',
        destinationURL: '',
        product: 'No',
      });
    }
  }, [isAutoshipDeactivatedPetsEnabled, track]);

  return isAutoshipDeactivatedPetsEnabled ? (
    <KibSectionHeading
      className="autoship-changes-card"
      data-testId="autoship-changes-card"
      heading={t('autoship.deactivatedPets.autoshipChangesTitle')}
      subheading={
        <>
          <div>{t('autoship.deactivatedPets.autoshipChangesMessage1')}</div>
          <div>{t('autoship.deactivatedPets.autoshipChangesMessage2')}</div>
        </>
      }
    >
      <KibButtonNew
        emphasis="tertiary"
        size="small"
        onClick={() => {
          track('Asset Clicked', {
            id: 'pet-profile-inactive-autoship-notification-button',
            parentId: 'autoship-manage',
            ancestorId: '',
            level: 'asset',
            type: 'button',
            subType: '',
            creative: 'manageAutoshipMemorializeRemoveProfile',
            contentPublisher: 'chewy-petprofile-ui',
            position: '2',
            destinationURL: '',
            product: 'No',
          });
          window.location.href = autoshipPath;
        }}
      >
        {t('autoship.manageAutoship')}
      </KibButtonNew>
    </KibSectionHeading>
  ) : null;
};

export default withTranslation()(AutoshipChangesCard);
